/**
 * Logic Necessary for Contributions
 */
const customInputs = [...document.querySelectorAll('input[data-custom')];
const customAmountRadio = document.querySelector('input[type="radio"]#level-custom');
const amountRadios = [...document.querySelectorAll('input[name="amount"]')];

const handleCustomRadioChange = () => {
    const associatedInput = document.querySelector("input[data-custom='level-custom']");

    if (customAmountRadio) {
        if (customAmountRadio.checked) {
            associatedInput.removeAttribute('disabled');
            associatedInput.setAttribute('required', 'required');
            associatedInput.style.pointerEvents = 'auto';
        } else {
            associatedInput.removeAttribute('required');
            associatedInput.setAttribute('disabled', 'disabled');
            associatedInput.style.pointerEvents = 'none';
        }
    }
};

window.addEventListener('load', handleCustomRadioChange);

// add event listener to amount radios and check if custom amount radio is checked
amountRadios.forEach(amountRadio => {
    amountRadio.addEventListener('change', handleCustomRadioChange);
});

customInputs.forEach(customInput => {
    customInput.addEventListener('focus', () => {
        const { custom } = customInput.dataset;
        const associatedInput = document.querySelector(`input[type='radio']#${custom}`);
        associatedInput.checked = true;
    });
});
